import styled from 'styled-components'

export const Header = styled.header`
  position: fixed;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
`
